module.exports = __webpack_public_path__ + "img/diretor_administrativo.db38a744.png";